import { useMutation } from "react-query";
import { createApiWithPath } from "../../client";
import { VoiceRequestStatus } from "../../types/voice-requests";

interface BulkUpdateVoiceRequestStatusPayload {
  ids: string[];
  status: VoiceRequestStatus;
}

export const useBulkUpdateVoiceRequestStatus = () => {
  return useMutation(async (payload: BulkUpdateVoiceRequestStatusPayload) => {
    const response = await createApiWithPath("voice-requests").patch(
      "/bulk-status",
      payload,
    );
    return response.data;
  });
};
